import classNames from 'classnames';
import React, {FC} from 'react';
import { Link } from 'react-router-dom';
import { ButtonDesign } from './Button';
import styles from "./Button.module.scss";

interface ButtonLinkProps{
    children: any;
    to: string;

    disabled?: boolean;
    design?: ButtonDesign;
    designType?: "button" | "icon-button" | "icon-before" | "icon-after"
    size?: "small" | "medium";
    weight?: 'normal' | 'light';
    
    display?: "inline" | "inline-block" | "block";
    className?: string;
}

const ButtonLink: FC<ButtonLinkProps> = ({
    children,
    to,
    disabled,
    design = "primary",
    size = "medium",
    display = "inline",
    weight,
    className,
}) => {


    const target = `${to.startsWith("http")? process.env.REACT_APP_BASEPATH:''}${to}`;

    return (
        <Link
            to={target}
            onClick={(e)=>{
                disabled && e.preventDefault();
            }}
            className={classNames(
                styles.btn,
                styles.btnLink,
                styles[`btn__${design}`],
                styles[`btn__${display}`],
                styles[`btn__${size}`],
                disabled && styles.btn__disabled,
                weight && styles[`btn__weight${weight}`],

                className && className,
            )}
        >
            {children}
        </Link>
    );
}
export default ButtonLink;

export const ButtonLinkExternal: FC<ButtonLinkProps> = ({
    children,
    to,
    design = "primary",
    size = "medium",
    display = "inline",
    className,
}) => {

    return (
        <a
            href={to}
            className={classNames(
                styles.btn,
                styles.btnLink,
                styles[`btn__${design}`],
                styles[`btn__${display}`],
                styles[`btn__${size}`],
                className && className,
            )}
        >
            {children}
        </a>
    );
}